import { VIRI, type Podjetje } from '@koda/shared';
import { useEffect, useState, type FormEvent, type JSX } from 'react';
import { Link } from 'react-router-dom';

import { api } from '../lib/api';
import { useBesedila } from '../lib/jezik';
import { useUporabnik } from '../lib/uporabnik';

/** Začetna stran: izbira ali ustvarjanje podjetja. */
export function Podjetja(): JSX.Element {
  const uporabnik = useUporabnik();
  const b = useBesedila();
  const [podjetja, setPodjetja] = useState<Podjetje[] | null>(null);
  const [napaka, setNapaka] = useState<string | null>(null);
  const [naziv, setNaziv] = useState('');
  const [vir, setVir] = useState('pantheon');
  const [shranjujem, setShranjujem] = useState(false);

  const osvezi = (): void => {
    api
      .podjetja()
      .then(setPodjetja)
      .catch((e: unknown) => {
        setNapaka(e instanceof Error ? e.message : b.podjetijNiMogoce);
      });
  };

  useEffect(osvezi, []);

  const dodaj = (dogodek: FormEvent): void => {
    dogodek.preventDefault();
    setShranjujem(true);
    setNapaka(null);
    api
      .ustvariPodjetje(naziv, vir)
      .then(() => {
        setNaziv('');
        osvezi();
      })
      .catch((e: unknown) => {
        setNapaka(e instanceof Error ? e.message : b.podjetjaNiMogoce);
      })
      .finally(() => {
        setShranjujem(false);
      });
  };

  return (
    <main>
      <h1>{b.znamka}</h1>
      <p className="podnaslov">{b.podnaslov}</p>

      {napaka !== null && <p className="napaka">{napaka}</p>}

      <section className="kartica">
        <h2>{b.podjetja}</h2>
        {podjetja === null && <p>{b.berem}</p>}
        {podjetja !== null && podjetja.length === 0 && uporabnik.jeAdmin && (
          <p>{b.brezPodjetijSkrbnik}</p>
        )}
        {podjetja !== null && podjetja.length === 0 && !uporabnik.jeAdmin && (
          <p>{b.brezPodjetijStranka}</p>
        )}
        {podjetja !== null && podjetja.length > 0 && (
          <ul className="seznam">
            {podjetja.map((p) => (
              <li key={p.id}>
                <Link to={`/podjetje/${p.id}`}>{p.naziv}</Link>
                <span className="drobno">{p.vir}</span>
              </li>
            ))}
          </ul>
        )}
      </section>

      {uporabnik.jeAdmin && (
      <section className="kartica">
        <h2>{b.novoPodjetje}</h2>
        <form onSubmit={dodaj} className="obrazec">
          <label>
            {b.naziv}
            <input
              value={naziv}
              onChange={(d) => {
                setNaziv(d.target.value);
              }}
              placeholder="npr. Tigos"
              required
            />
          </label>
          <label>
            {b.virKnjizb}
            <select
              value={vir}
              onChange={(d) => {
                setVir(d.target.value);
              }}
            >
              {VIRI.map((v) => (
                <option key={v.koda} value={v.koda}>
                  {v.uvozPodprt ? v.naziv : b.uvozNiPodprt(v.naziv)}
                </option>
              ))}
            </select>
          </label>
          <button type="submit" disabled={shranjujem || naziv.trim() === ''}>
            {shranjujem ? b.shranjujem : b.ustvari}
          </button>
        </form>
      </section>
      )}
    </main>
  );
}
